import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { OrderedMap } from "immutable";

import TakeoverPanel from "components/library/TakeoverPanel";
import TakeoverHeader from "components/library/TakeoverHeader";
import Button from "components/library/Button";
import Icon from "components/library/Icon";
import LinkButton from "components/library/LinkButton";
import ReducedTagRow from "settings/components/TagRow/ReducedTagRow";

import { deleteTagsAsync } from "settings/actions/tags";
import { setMessage } from "actions/message";
import styles from "./DeleteTag.css";

class DeleteTag extends React.Component {
  constructor(props) {
    super(props);
    this.tags = props.tags
      .toArray()
      .filter(tag => this.props.selectedTags[tag.id]);

    this.deleteTags = this._deleteTags.bind(this);

    this.state = { wasClicked: false };
  }

  _deleteTags() {
    this.setState({ wasClicked: true });
    return this.props
      .deleteTagsAsync(this.tags)
      .then(() => {
        let phrasing = this.tags.length > 1 ? "s were" : " was";
        this.props.history.push("/settings/tags");
        this.props.setMessage({
          message: (
            <div>
              <Icon name="check/square" className={styles.icon} />
              <span>The selected tag{phrasing} deleted</span>
            </div>
          ),
        });
      })
      .catch(error => {
        this.props.setMessage({ message: error });
        this.setState({ wasClicked: false });
      });
  }

  render() {
    return (
      <TakeoverPanel>
        <TakeoverHeader className={styles.header}>
          Are you sure you want to delete{" "}
          {this.tags.length > 1 ? "these tags" : "this tag"}?
        </TakeoverHeader>
        <p className={styles.info}>
          {" "}
          While {this.tags.length > 1 ? "these tags" : "this tag"} will no
          longer appear on Axios.com, stories tagged with{" "}
          {this.tags.length > 1 ? "them" : "it"} will retain all remaining tags.
        </p>
        <div>
          {this.tags.map(tag => {
            return (
              <ReducedTagRow
                className={styles.warning}
                key={tag.id}
                tag={tag}
              />
            );
          })}
        </div>

        <Button
          type="submit"
          onClick={this.deleteTags}
          isDisabled={this.state.wasClicked}
          className={styles.submit}
        >
          Yes, delete
        </Button>
        <LinkButton to="/settings/tags" type="cancel">
          No, cancel
        </LinkButton>
      </TakeoverPanel>
    );
  }
}

const mapStateToProps = state => ({
  tags: state.settings.tags.tags,
  selectedTags: state.settings.tags.selected,
});

const mapDispatchToProps = {
  deleteTagsAsync,
  setMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteTag);

DeleteTag.propTypes = {
  setMessage: PropTypes.func.isRequired,
  deleteTagsAsync: PropTypes.func.isRequired,
  selectedTags: PropTypes.object.isRequired,
  tags: PropTypes.instanceOf(OrderedMap).isRequired,
};
